/**
 * This function take a RGB color as string and a number between 1 and 0 and transform the RGB to RGBA
 */
export const transformRGBtoRGBA = (colorRGB, transparency = 0.5) => {
    let safeTransparency = transparency;
    let safeColorRGB = colorRGB;
    const regexRGB = new RegExp('^rgb[(](?:s*0*(?:dd?(?:.d+)?(?:s*%)?|.d+s*%|100(?:.0*)?s*%|(?:1dd|2[0-4]d|25[0-5])(?:.d+)?)s*(?:,(?![)])|(?=[)]))){3}[)]$');
    if (safeTransparency > 1 || safeTransparency < 0) {
        safeTransparency = 1;
    }
    if (regexRGB.test(safeColorRGB)) {
        safeColorRGB = 'rgb(255, 255, 255)';
    }
    return safeColorRGB.replace(')', `, ${safeTransparency})`).replace('rgb', 'rgba');
};
//# sourceMappingURL=colors.js.map